"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
/**
 * Debounce a function call.
 *
 * @example
 * const func = debounce(() => console.log('debounce'), 100);
 *
 * func();
 * func();
 * func();
 *
 * // Will print only one 'debounce' after 100 ms.
 *
 * @param func Function to debounce.
 * @param wait Milliseconds to wait until next call.
 * @param immediate Run immediate.
 */
function debounce(func, wait, immediate = false) {
    let timeout;
    const res = function () {
        let that = this;
        let args = [];
        for (let i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        const later = () => {
            timeout = 0;
            if (!immediate) {
                func.apply(that, args);
            }
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(that, args);
        }
    };
    return res;
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map